<template>
    <div class="login-container">
        <div class="login-card">
            <div class="login-header">
                <img src="../assets/utility/logo/Logo LR Pro Marketing - circular - sin slogan.png" alt="LR Pro Marketing" class="logo">
                <h1>Panel Administrativo</h1>
                <p>Inicia sesión para gestionar tu portafolio</p>
            </div>

            <form @submit.prevent="handleLogin" class="login-form">
                <div class="form-group">
                    <label for="username">Usuario</label>
                    <input 
                        type="text" 
                        id="username" 
                        v-model="credentials.username" 
                        required
                        placeholder="Ingresa tu usuario"
                    >
                </div>

                <div class="form-group">
                    <label for="password">Contraseña</label>
                    <div class="password-input">
                        <input 
                            :type="showPassword ? 'text' : 'password'" 
                            id="password" 
                            v-model="credentials.password" 
                            required
                            placeholder="Ingresa tu contraseña"
                        >
                        <button 
                            type="button" 
                            class="password-toggle"
                            @click="togglePassword"
                        >
                            <i :class="showPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"></i>
                        </button>
                    </div>
                </div>

                <div class="form-group">
                    <label class="checkbox-label">
                        <input type="checkbox" v-model="rememberMe">
                        <span class="checkmark"></span>
                        Recordar sesión
                    </label>
                </div>

                <button type="submit" class="login-btn" :disabled="loading">
                    <span v-if="loading">Iniciando sesión...</span>
                    <span v-else>Iniciar Sesión</span>
                </button>
            </form>

            <div v-if="error" class="error-message">
                {{ error }}
            </div>
        </div>
    </div>
</template>

<script>
import apiService from '../config/api.js';

export default {
    name: 'LoginPage',
    data() {
        return {
            credentials: {
                username: '',
                password: ''
            },
            showPassword: false,
            rememberMe: false,
            loading: false,
            error: ''
        }
    },
    methods: {
        async handleLogin() {
            this.loading = true;
            this.error = '';

            try {
                console.log('🔐 Intentando login con:', this.credentials.username);
                
                const response = await apiService.login(this.credentials.username, this.credentials.password);
                console.log('📡 Respuesta del login:', response);
                
                if (response && response.success) {
                    // Guardar token y datos del usuario
                    localStorage.setItem('authToken', response.token);
                    localStorage.setItem('user', JSON.stringify(response.user));
                    
                    if (this.rememberMe) {
                        localStorage.setItem('rememberMe', 'true');
                    }
                    
                    console.log('✅ Login exitoso, redirigiendo al dashboard');
                    this.$router.push('/dashboard/#');
                } else {
                    const errorMsg = response?.error || 'Usuario o contraseña incorrectos';
                    console.error('❌ Error en login:', errorMsg);
                    this.error = errorMsg;
                }
            } catch (error) {
                console.error('❌ Error al iniciar sesión:', error);
                this.error = 'Error al iniciar sesión. Intenta nuevamente.';
            } finally {
                this.loading = false;
            }
        },
        togglePassword() {
            this.showPassword = !this.showPassword;
        }
    }
}
</script>

<style lang="scss" scoped>
.login-container {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 20px;
    font-family: 'Poppins', sans-serif;

    .login-card {
        background: white;
        border-radius: 20px;
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
        padding: 40px;
        width: 100%;
        max-width: 400px;
        position: relative;
        overflow: hidden;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 4px;
            background: linear-gradient(90deg, #1f8cc6, #f08908);
        }

        .login-header {
            text-align: center;
            margin-bottom: 30px;

            .logo {
                width: 80px;
                height: 80px;
                margin-bottom: 20px;
            }

            h1 {
                font-size: 24px;
                font-weight: 600;
                color: #333;
                margin-bottom: 10px;
            }

            p {
                color: #666;
                font-size: 14px;
            }
        }

        .login-form {
            .form-group {
                margin-bottom: 20px;

                label {
                    display: block;
                    margin-bottom: 8px;
                    font-weight: 500;
                    color: #333;
                    font-size: 14px;
                }

                input[type="text"],
                input[type="password"] {
                    width: 100%;
                    padding: 12px 16px;
                    border: 2px solid #e1e5e9;
                    border-radius: 8px;
                    font-size: 14px;
                    transition: border-color 0.3s ease;

                    &:focus {
                        outline: none;
                        border-color: #1f8cc6;
                    }

                    &::placeholder {
                        color: #999;
                    }
                }

                .password-input {
                    position: relative;

                    .password-toggle {
                        position: absolute;
                        right: 12px;
                        top: 50%;
                        transform: translateY(-50%);
                        background: none;
                        border: none;
                        color: #666;
                        cursor: pointer;
                        padding: 0;
                        font-size: 16px;

                        &:hover {
                            color: #1f8cc6;
                        }
                    }
                }

                .checkbox-label {
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    font-size: 14px;
                    color: #666;

                    input[type="checkbox"] {
                        display: none;
                    }

                    .checkmark {
                        width: 18px;
                        height: 18px;
                        border: 2px solid #e1e5e9;
                        border-radius: 4px;
                        margin-right: 10px;
                        position: relative;
                        transition: all 0.3s ease;

                        &::after {
                            content: '';
                            position: absolute;
                            left: 5px;
                            top: 2px;
                            width: 6px;
                            height: 10px;
                            border: solid white;
                            border-width: 0 2px 2px 0;
                            transform: rotate(45deg);
                            opacity: 0;
                            transition: opacity 0.3s ease;
                        }
                    }

                    input[type="checkbox"]:checked + .checkmark {
                        background: #1f8cc6;
                        border-color: #1f8cc6;

                        &::after {
                            opacity: 1;
                        }
                    }
                }
            }

            .login-btn {
                width: 100%;
                padding: 14px;
                background: linear-gradient(135deg, #1f8cc6, #f08908);
                color: white;
                border: none;
                border-radius: 8px;
                font-size: 16px;
                font-weight: 600;
                cursor: pointer;
                transition: all 0.3s ease;
                margin-top: 10px;

                &:hover:not(:disabled) {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 20px rgba(31, 140, 198, 0.3);
                }

                &:disabled {
                    opacity: 0.7;
                    cursor: not-allowed;
                }
            }
        }

        .error-message {
            background: #fee;
            color: #c33;
            padding: 12px;
            border-radius: 8px;
            margin-top: 20px;
            font-size: 14px;
            text-align: center;
        }
    }
}

// Dark theme
body.dark-theme .login-container {
    background: linear-gradient(135deg, #1f2122 0%, #2b2a2a 100%);

    .login-card {
        background: #1f2122;
        color: white;

        .login-header {
            h1 {
                color: #ffffff;
            }

            p {
                color: #ccc;
            }
        }

        .login-form {
            .form-group {
                label {
                    color: #ffffff;
                }

                input[type="text"],
                input[type="password"] {
                    background: #2b2a2a;
                    border-color: #444;
                    color: #ffffff;

                    &:focus {
                        border-color: #f08908;
                    }

                    &::placeholder {
                        color: #999;
                    }
                }

                .checkbox-label {
                    color: #ccc;

                    .checkmark {
                        border-color: #444;
                    }
                }
            }
        }
    }
}

// Responsive
@media (max-width: 480px) {
    .login-container {
        padding: 10px;

        .login-card {
            padding: 30px 20px;

            .login-header {
                h1 {
                    font-size: 20px;
                }
            }
        }
    }
}
</style> 